import { supabase } from "../lib/supabase";

export const notificationQueueService = {
  async getQueue({ status, type, limit = 50, offset = 0 } = {}) {
    let query = supabase
      .from("notification_queue")
      .select("*", { count: "exact" })
      .order("created_at", { ascending: false })
      .range(offset, offset + limit - 1);

    if (status) query = query.eq("status", status);
    if (type) query = query.eq("notification_type", type);

    const { data, error, count } = await query;
    if (error) throw error;
    return { notifications: data || [], total: count };
  },

  async getQueueStats() {
    const { data, error } = await supabase
      .from("notification_queue")
      .select("status, notification_type");

    if (error) throw error;

    const statusCounts = new Map([
      ["pending", 0],
      ["sent", 0],
      ["failed", 0],
    ]);
    const typeCounts = new Map();
    (data || []).forEach((n) => {
      if (statusCounts.has(n.status)) {
        statusCounts.set(n.status, statusCounts.get(n.status) + 1);
      }
      typeCounts.set(
        n.notification_type,
        (typeCounts.get(n.notification_type) || 0) + 1,
      );
    });
    return {
      total: data?.length || 0,
      pending: statusCounts.get("pending"),
      sent: statusCounts.get("sent"),
      failed: statusCounts.get("failed"),
      byType: Object.fromEntries(typeCounts),
    };
  },

  async queueNotification({
    recipientEmail,
    recipientName,
    recipientUserId,
    notificationType,
    platform,
    data,
    relatedBatchId,
    relatedSessionId,
    scheduledFor,
    replyTo,
    deduplicationKey,
  }) {
    if (relatedBatchId) {
      const { data: notificationId, error } = await supabase.rpc(
        "queue_batch_notification",
        {
          p_recipient_email: recipientEmail,
          p_recipient_name: recipientName,
          p_recipient_user_id: recipientUserId,
          p_notification_type: notificationType,
          p_platform: platform || "ISOGYAAN",
          p_metadata: data || {},
          p_related_batch_id: relatedBatchId,
          p_related_session_id: relatedSessionId || null,
          p_scheduled_for: scheduledFor || new Date().toISOString(),
          p_reply_to: replyTo || null,
          p_deduplication_key: deduplicationKey || null,
        },
      );
      if (error) throw error;
      return { queued: true, notificationId };
    }

    const payload = {
      recipient_email: recipientEmail,
      recipient_name: recipientName,
      recipient_user_id: recipientUserId,
      notification_type: notificationType,
      platform: platform || "ISOGYAAN",
      metadata: data || {},
      related_batch_id: null,
      related_session_id: null,
      scheduled_for: scheduledFor || new Date().toISOString(),
      reply_to: replyTo || null,
      deduplication_key: deduplicationKey || null,
    };
    const query = deduplicationKey
      ? supabase.from("notification_queue").upsert(payload, {
          onConflict: "deduplication_key",
          ignoreDuplicates: true,
        })
      : supabase.from("notification_queue").insert(payload);
    const { error } = await query;
    if (error) throw error;
    return { queued: true };
  },
};
